'use strict'

import Axios from 'axios'
import Store from '@/store'
import qs from 'qs';
import { parseResponse, handleError } from '@/_helpers/utils.js'

export default {
  fetch (params) {
    console.log('PARAMS', params)
    return new Promise((resolve, reject) => {
      let url = '/1.0/invites'

      if (Store.state.process.companyCommonSpecialProcess === 'sportmaster') {
        url = '/1.0/spec-private/sportmaster/invites'
      }

      Axios.get(url, {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchOne (id) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/invites/${id}`)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  createNewInvites (models, forceInvite) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/invites?force=${forceInvite}`, {invites: models})
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  getExcelImportLink (params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/invites/report/xls', {
        params: params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  importFromFile (file) {
    let data = new FormData()
    data.append('sources[]', file)
    return Axios.post(`1.0/invites-from-xls`, data)
        .then(response => {
          let res = parseResponse(response).data;
          let errors = [];
          if(response.data.meta.error !== null) {
            errors = response.data.meta.error.details.invites;
          }
          return Promise.resolve([...errors, ...res])
        })
      .catch(err => Promise.reject(handleError(err)))
  }
}
